import { Box } from '@leagueplatform/genesis-core';
import { OnboardingFlowContainerProps } from 'types/types';

export const OnboardingFlowContainer = ({
  children,
  css,
  isMobile,
}: OnboardingFlowContainerProps) => (
  <Box
    css={{
      backgroundColor: '$surfaceCardSecondary',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      padding: isMobile ? '$oneAndHalf' : '$twoAndHalf',
      boxSizing: 'border-box',
      overflowY: 'auto',
      height: isMobile ? '100dvh' : '',
      paddingTop: isMobile ? '104px' : '',
      ...css,
    }}
  >
    {children}
  </Box>
);
